module.exports = __webpack_public_path__ + "static/media/tools.6866351b.png";